// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__GrHNp","profileTitle":"Profile_profileTitle__LvoT1","profileList":"Profile_profileList__jrU-u","profileItem":"Profile_profileItem__jHiU7"};